import { render, staticRenderFns } from "./RequestDetails.vue?vue&type=template&id=24748aae&scoped=true"
import script from "./RequestDetails.vue?vue&type=script&lang=ts"
export * from "./RequestDetails.vue?vue&type=script&lang=ts"
import style0 from "./RequestDetails.vue?vue&type=style&index=0&id=24748aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24748aae",
  null
  
)

export default component.exports